import { useEffect, useState } from 'react';
import { getAllParties } from '../../controller/PartyDB';
import { IPartyForUser } from '../../PartyClientResponse';
import { Button, Input, Table } from 'antd';
import HomeButton from '../common/HomeButton';

const PartyList = () => {
  const [partyKey, setPartyKey] = useState<string>('');
  const [parties, setParty] = useState<IPartyForUser[]>([]);

  useEffect(() => {
    getAllParties()
      .then((partyResp) => {
        setParty(partyResp);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [partyKey]);


  const dataSource = partyKey ? parties?.filter(item => item?.displayName.includes(partyKey)) : parties;

  const columns = [
    {
      title: 'display Name',
      dataIndex: 'displayName',
      key: 'displayName',
      sorter: (a: { displayName: string; }, b: { displayName: string; }) => (a.displayName < b.displayName ? 1 : -1),
    },
    {
      title: 'url',
      dataIndex: 'slug',
      key: 'slug',
      render: (val: string) => <Button
        onClick={() => {
          navigator.clipboard.writeText(`${window.location.origin}/${val}`);
        }}>
        copy
      </Button>
    },
  ];

  return (
    <div className='onboarding-container'>
      <HomeButton />
      <div className='admin-card'>
        <div className='onboarding-title'>party list</div>
        <div style={{ display: 'flex' }}>
          <Input
            placeholder='filter on party name'
            value={partyKey}
            onChange={(e) => setPartyKey(e.target.value)}
          />
        </div>
        <div className='json-container'>
          {parties && <Table dataSource={dataSource} columns={columns} pagination={false} />}
        </div>
      </div>
    </div>
  );
};

export default PartyList;
